import classNames from "classnames";
import { ReactElement } from "react";

import NavLink from "../NavLink/NavLink";
import Prose from "../Prose/Prose";

import styles from "./Hero.module.css";

const Hero: React.FC<HeroProps> = ({
  breadcrumbs,
  title,
  titleInMobile,
  description,
  noDescriptionProse,
  className,
}) => (
  <div className={classNames(styles.wrapper, className, "grid")}>
    <nav aria-label="Breadcrumbs">
      <ul className={styles.breadcrumbs}>
        {breadcrumbs.map((breadcrumb, i) => (
          <li key={i}>
            <NavLink href={breadcrumb.path}>{breadcrumb.title}</NavLink>
          </li>
        ))}
      </ul>
    </nav>
    <div className={styles.content}>
      <h1
        className={classNames(styles.title, {
          [styles.titleInMobile]: titleInMobile,
        })}
      >
        {title}
      </h1>
      {description && !noDescriptionProse && (
        <Prose className={styles.description}>{description}</Prose>
      )}
      {description && noDescriptionProse && (
        <div className={styles.description}>{description}</div>
      )}
    </div>
  </div>
);

export default Hero;

export type HeroProps = {
  title: string;
  titleInMobile?: boolean;
  description?: ReactElement | string;
  breadcrumbs: Array<{
    title: string;
    path: string;
  }>;
  className?: string;
  /* Temporary way of not including Prose component on description.
  Prose on description should be removed on next stable release. Clients should implement it instead */
  noDescriptionProse?: boolean;
};
